import { Component, Injector, Optional } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-repeat-item';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-repeat-template',
  hostClass: DEFAULT_CLS
};

@Component({
  selector: '[wmRepeatTemplate]',
  template: `<div class="wm-content-info">
    <p class="wm-message" title="This template will be repeated over the dataset bound to the widget">This template will be repeated over the dataset bound to the widget</p>
  </div><ng-content></ng-content>`,
  providers: [
    provideAsWidgetRef(RepeatTemplateDirective)
  ],
  standalone: true,
  exportAs: 'wmRepeatTemplate'
})
export class RepeatTemplateDirective extends StylableComponent {
  static initializeProps = register('wm-repeat-template');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
}
